/* advertorial-buy-now.js
 * Intercepts the Add to Cart form on the advertorial layout and redirects
 * straight to checkout, correctly handling the bundle selector.
 * Uses continuous polling to enforce BUY NOW label against theme JS overwrites.
 */
(function() {
  if (window.__useDefaultCart) return;
  function setBuyNowLabel(btn) {
    if (!btn) return;
    var span = btn.querySelector('span:first-child');
    if (span) {
      if (span.textContent !== 'BUY NOW') {
        span.textContent = 'BUY NOW';
      }
      // Ensure font size is visible
      span.style.fontSize = '';
      span.style.visibility = '';
    } else if (btn.textContent.trim() !== 'BUY NOW') {
      btn.textContent = 'BUY NOW';
    }
  }

  function getItems() {
    var items = [];
    var checkedQtyRadio = document.querySelector('input[name="quantity"]:checked');
    if (checkedQtyRadio) {
      var qty = checkedQtyRadio.value;
      var activeLabel = document.querySelector('label.quantity-break[data-quantity="' + qty + '"]');
      if (activeLabel) {
        var bundleSelects = Array.from(activeLabel.querySelectorAll('select'));
        bundleSelects.forEach(function(sel) {
          if (sel.value) {
            items.push({ id: parseInt(sel.value, 10), quantity: 1 });
          }
        });
      }
    }
    if (items.length === 0) {
      document.querySelectorAll('[data-type="add-to-cart-form"] input[name="id"]').forEach(function(inp) {
        if (!inp.disabled && inp.value && inp.value !== 'undefined') {
          items.push({ id: parseInt(inp.value, 10), quantity: 1 });
        }
      });
    }
    if (items.length === 0) {
      var variantInput = document.querySelector('[data-type="add-to-cart-form"] input.product-variant-id');
      if (variantInput && variantInput.value) {
        items.push({ id: parseInt(variantInput.value, 10), quantity: 1 });
      }
    }
    return items;
  }

  function bindForm(form) {
    if (form._buyNowBound) return;
    form._buyNowBound = true;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
      }
      var items = getItems();
      if (items.length === 0) {
        window.location.href = '/checkout';
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function() { window.location.href = '/checkout'; })
      .catch(function() { window.location.href = '/checkout'; });
    }, true);
  }

  function enforce() {
    document.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function(form) {
      bindForm(form);
      var btn = form.querySelector('button[type="submit"]');
      setBuyNowLabel(btn);
    });
  }

  function init() {
    enforce();
    // Poll every 200ms to continuously enforce the label
    setInterval(enforce, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
